export default "__VITE_PUBLIC_ASSET__2f290042__"